<template>
  <div class="app-container">
    <!-- 导航栏 -->
    <nav class="navbar">
      <div class="logo">
        <img src="./assets/logo.png" alt="智匠坊科技logo">
        <span class="company-name">北京智匠坊科技</span>
      </div>
      
      <div class="menu-toggle" @click="toggleMenu">
        <i class="fas fa-bars"></i>
      </div>

      <ul class="nav-links" :class="{ 'active': isMenuOpen }">
        <li><a href="#home">首页</a></li>
        <li><a href="#about">关于我们</a></li>
        <li><a href="#products">产品服务</a></li>
        <li><a href="#advantages">核心优势</a></li>
        <li><a href="#contact">联系我们</a></li>
      </ul>
    </nav>

    <!-- 首页横幅 -->
    <section id="home" class="hero">
      <div class="hero-content">
        <h1>智能科技 引领未来</h1>
        <p>助力中小企业提升管理效率和创新能力</p>
        <button class="cta-button" @click="showContactModal = true">了解更多</button>
      </div>
    </section>

    <!-- 关于我们 -->
    <section id="about" class="about-section">
      <h2>关于我们</h2>
      <div class="about-content">
        <div class="about-image">
          <img src="./assets/about-us.jpg" alt="关于我们">
        </div>
        <div class="about-text-content">
          <div class="about-text">
            <p>智匠坊科技有限公司成立于2024年，前身为2018年成立的汉思网络科技（香河）有限公司。</p>
            <p>我们致力于为中小企业提供数字化转型解决方案，通过最新的技术，帮助客户提升运营效率。</p>
          </div>
          <div class="company-values">
            <div class="value-item">
              <img src="./assets/vision-icon.jpg" alt="愿景">
              <h3>愿景</h3>
              <p>打造智能化解决方案，助力中小企业提升管理效率和创新能力</p>
            </div>
            <div class="value-item">
              <img src="./assets/mission-icon.png" alt="使命">
              <h3>使命</h3>
              <p>通过先进的技术和专业的服务，帮助客户在激烈的市场竞争中脱颖而出</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 产品服务 -->
    <section id="products" class="products-section">
      <h2>核心产品与服务</h2>
      <div class="products-grid">
        <div class="product-card">
          <div class="product-icon">
            <img src="./assets/mall-system.jpg" alt="数字化商城系统">
          </div>
          <h3>商城系统</h3>
          <p>为中小企业量身定制的全渠道电商解决方案</p>
        </div>
        <div class="product-card">
          <div class="product-icon">
            <img src="./assets/vi-system.jpg" alt="视觉设计">
          </div>
          <h3>视觉设计</h3>
          <p>品牌设计与电商设计，全面提升企业与产品形象</p>
        </div>
        <div class="product-card">
          <div class="product-icon">
            <img src="./assets/crm-system.jpg" alt="管理系统">
          </div>
          <h3>管理系统</h3>
          <p>全面的企业资源管理系统，提升企业运营效率</p>
        </div>
        <div class="product-card">
          <div class="product-icon">
            <img src="./assets/marketing-system.jpg" alt="智能营销系统">
          </div>
          <h3>营销方案</h3>
          <p>基于AI和大数据的精准营销解决方案</p>
        </div>
      </div>
    </section>

    <!-- 核心优势 -->
    <section id="advantages" class="advantages-section">
      <h2>我们的优势</h2>
      <div class="advantages-grid">
        <div class="advantage-item">
          <div class="advantage-icon">
            <img src="./assets/tech-icon.jpg" alt="技术领先">
          </div>
          <h3>技术领先</h3>
          <p>资深工程师团队，强大的技术研发能力</p>
        </div>
        <div class="advantage-item">
          <div class="advantage-icon">
            <img src="./assets/customer-icon.png" alt="客户至上">
          </div>
          <h3>客户至上</h3>
          <p>注重长期合作，提供个性化服务</p>
        </div>
        <div class="advantage-item">
          <div class="advantage-icon">
            <img src="./assets/experience-icon.png" alt="行业经验">
          </div>
          <h3>行业经验</h3>
          <p>丰富的企业服务经验，准确把握行业痛点</p>
        </div>
        <div class="advantage-item">
          <div class="advantage-icon">
            <img src="./assets/agile-icon.jpg" alt="科技赋能">
          </div>
          <h3>科技赋能</h3>
          <p>全新AI技术革命，提升业务效率</p>
        </div>
      </div>
    </section>

    <section id="contact" class="contact-section">
      <h2>体验产品</h2>
      <div class="contact-content">
        <div class="qr-codes">
          <div class="qr-item">
            <img src="./assets/qrcode/qrcode_bjzjf.jpg" alt="微信公众号">
            <p>微信公众号</p>
          </div>
          <div class="qr-item">
            <img src="./assets/qrcode/sxys.jpg" alt="手心云商">
            <p>手心云商</p>
          </div>
          <div class="qr-item">
            <img src="./assets/qrcode/official.png" alt="微官网">
            <p>微官网</p>
          </div> 
          <div class="qr-item">
            <img src="./assets/qrcode/eoss.png" alt="数字化管理平台（PC）">
            <p>数字化管理平台（PC）</p>
          </div>
          <div class="qr-item">
            <img src="./assets/qrcode/xcx_bjzjf.jpg" alt="智匠坊官方">
            <p>智匠坊营销(微信)</p>
          </div>
          <div class="qr-item">
            <img src="./assets/qrcode/yszs.jpg" alt="云商助手">
            <p>智匠坊营销(抖音)</p>
          </div> 
        </div>
      </div>
    </section>
   <!-- 联系我们 -->
    <section id="contact" class="contact-section">
      <h2>联系我们</h2>
      <div class="contact-content">
        <div class="contact-info">
          <div class="info-item">
            <i class="fas fa-map-marker-alt"></i>
            <h3>公司地址</h3>
            <p>北京市顺义区北小营镇李木路3号179室</p>
          </div>
          <div class="info-item">
            <i class="fas fa-phone"></i>
            <h3>联系电话</h3>
            <p>+86-18033696803</p>
            <p></p>
          </div>
        </div>
      </div>
    </section>

    <!-- 底部信息 -->
    <footer class="footer">
      <div class="footer-content">
        <div class="footer-info">
          <p>© 2024 北京智匠坊科技有限公司 版权所有</p>
          <p>
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
              京ICP备2024062337号-1
            </a>
          </p>
        </div>
      </div>
    </footer>

    <!-- 联系方式弹窗 -->
    <div class="modal" v-if="showContactModal" @click.self="showContactModal = false">
      <div class="modal-content">
        <div class="modal-header">
          <h3>联系我们</h3>
          <button class="close-button" @click="showContactModal = false">&times;</button>
        </div>
        <div class="modal-body">
          <div class="contact-modal-info">
            <div class="phone-info">
              <i class="fas fa-phone"></i>
              <h4>联系电话</h4>
              <p>+86-18033696803</p>
            </div>
            <div class="qr-info">
              <img src="./assets/wechat-qr.jpg" alt="微信二维码">
              <p>扫码添加微信</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isMenuOpen: false,
      showContactModal: false
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    }
  }
}
</script>

<style>
/* 基础样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.app-container {
  font-family: 'Microsoft YaHei', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

/* 导航栏样式 */
.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 5%;
  background: white;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  z-index: 1000;
}

.logo {
  display: flex;
  align-items: center;
}

.logo img {
  height: 30px;
  margin-right: 10px;
}

.company-name {
  font-size: 1.2rem;
  font-weight: bold;
}

.nav-links {
  display: flex;
  list-style: none;
}

.nav-links li {
  margin: 0 1.5rem;
}

.nav-links a {
  text-decoration: none;
  color: #2c3e50;
  font-weight: 500;
}

/* 首页横幅样式 */
.hero {
  height: 85vh;
  background:  url('./assets/hero-bg.jpg');
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
}

.hero-content {
  padding: 2rem;
}

.hero-content h1 {
  font-size: 3.5rem;
  margin-bottom: 1rem;
}

.cta-button {
  margin-top: 2rem;
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  background-color: #1890ff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.cta-button:hover {
  background-color: #40a9ff;
}

/* 公共部分样式 */
section {
  padding: 5rem 10%;
}

section h2 {
  text-align: center;
  margin-bottom: 3rem;
  font-size: 2.2rem;
}

/* 产品服务样式 */
.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.product-card {
  background: #f8f9fa;
  padding: 2rem;
  border-radius: 8px;
  text-align: center;
  transition: transform 0.3s;
}

.product-card:hover {
  transform: translateY(-5px);
}

/* 核心优势样式 */
.advantages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.advantage-item {
  text-align: center;
  padding: 1.5rem;
  background: #f8f9fa;
  border-radius: 8px;
  transition: transform 0.3s;
}

.advantage-item:hover {
  transform: translateY(-5px);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .menu-toggle {
    display: block;
    cursor: pointer;
  }

  .nav-links {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: white;
    flex-direction: column;
    padding: 1rem 0;
  }

  .nav-links.active {
    display: flex;
  }

  .nav-links li {
    margin: 1rem 0;
  }

  .hero-content h1 {
    font-size: 2rem;
  }

  section {
    padding: 3rem 5%;
  }
}

@media (min-width: 769px) {
  .menu-toggle {
    display: none;
  }
}

/* 关于我们部分样式更新 */
.about-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
}

.about-image img {
  width: 100%;
  border-radius: 5px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
}

.about-text-content {
  text-align: left;
}

.company-values {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-top: 2rem;
  width: 100%;
}

.value-item {
  width: 100%;
}

.value-item img {
  width: 100%;
  height: auto;
  margin-bottom: 1rem;
  border-radius: 5px;
}

/* 响应式设计补充 */
@media (max-width: 768px) {
  .about-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .company-values {
    grid-template-columns: 1fr;
    width: 90%;
    margin: 1.5rem auto;
  }

  .about-image {
    order: -1;
  }

  .value-item {
    width: 100%;
    margin: 0 auto;
  }

  .value-item img {
    width: 100%;
    height: auto;
  }

  .value-item h3 {
    font-size: 1.2rem;
    margin: 0.8rem 0;
  }

  .value-item p {
    font-size: 0.9rem;
    line-height: 1.4;
    max-width: 280px;
    margin: 0 auto;
  }

  /* 调整间距 */
  .company-values {
    gap: 1.5rem;
    margin-top: 1.5rem;
  }
}

/* 更小屏幕的特殊处理 */
@media (max-width: 480px) {
  .value-item img {
    width: 280px;
    height: 280px;
  }

  .value-item p {
    max-width: 240px;
  }
}

/* 产品服务样式更新 */
.product-icon {
  margin-bottom: 1.5rem;
}

.product-icon img {
  width: 100%;
  height: auto;
  transition: transform 0.3s;
  border-radius: 5px;
}

.product-card:hover .product-icon img {
  transform: scale(1.1);
}

/* 核心优势样式更新 */
.advantage-icon {
  margin-bottom: 1.5rem;
}

.advantage-icon img {
  width: 100%;
  height: auto;
  transition: transform 0.3s;
  border-radius: 5px;
}

.advantage-item:hover .advantage-icon img {
  transform: scale(1.1);
}

/* 响应式设计补充 */
@media (max-width: 768px) {
  .about-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .company-values {
    grid-template-columns: 1fr;
  }

  .about-image {
    order: -1;
  }
}

/* 联系我们样式 */
.contact-section {
  background-color: white;
}

.contact-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: start;
}

.contact-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.info-item {
  text-align: center;
  padding: 2rem;
  background: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  transition: transform 0.3s;
}

.info-item:hover {
  transform: translateY(-5px);
}

.info-item i {
  font-size: 2rem;
  color: #1890ff;
  margin-bottom: 1rem;
}

.info-item h3 {
  margin-bottom: 1rem;
  color: #2c3e50;
}

.info-item p {
  color: #666;
  line-height: 1.6;
}

.qr-codes {
  display: flex;
  justify-content: center;
  gap: 3rem;
}

.qr-item {
  text-align: center;
  transition: transform 0.3s;
}

.qr-item:hover {
  transform: translateY(-5px);
}

.qr-item img {
  width: 200px;
  height: 200px;
  border-radius: 8px;
  margin-bottom: 1rem;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.qr-item p {
  color: #666;
  font-size: 1.1rem;
}

/* 底部样式 */
.footer {
  background-color: #2c3e50;
  color: white;
  padding: 2rem 5%;
  text-align: center;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
}

.footer-info p {
  margin: 0.5rem 0;
}

.footer-info a {
  color: white;
  text-decoration: none;
  opacity: 0.8;
  transition: opacity 0.3s;
}

.footer-info a:hover {
  opacity: 1;
}

/* 响应式设计补充 */
@media (max-width: 768px) {
  .contact-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .contact-info {
    grid-template-columns: 1fr;
  }

  .qr-codes {
    flex-direction: column;
    align-items: center;
    gap: 2rem;
  }

  .info-item {
    padding: 1.5rem;
  }
}

/* 弹窗样式 */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  position: relative;
  animation: modalFadeIn 0.3s;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-header {
  padding: 1.5rem;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  color: #2c3e50;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
  padding: 0 0.5rem;
}

.close-button:hover {
  color: #333;
}

.modal-body {
  padding: 2rem;
}

.contact-modal-info {
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 2rem;
}

.phone-info {
  text-align: center;
}

.phone-info i {
  font-size: 2rem;
  color: #1890ff;
  margin-bottom: 1rem;
}

.phone-info h4 {
  margin-bottom: 0.5rem;
  color: #2c3e50;
}

.phone-info p {
  color: #666;
  font-size: 1.1rem;
}

.qr-info {
  text-align: center;
}

.qr-info img {
  width: 150px;
  height: 150px;
  border-radius: 8px;
  margin-bottom: 0.5rem;
}

.qr-info p {
  color: #666;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .contact-modal-info {
    flex-direction: column;
    gap: 1.5rem;
  }

  .modal-content {
    width: 95%;
    margin: 0 1rem;
  }
}
</style>
